module.exports = __webpack_public_path__ + "static/media/nighttime.b34b6e66.svg";